module.exports = __webpack_public_path__ + "media/images/icon_name-1e9c47ad9d85c2416c1bd7cd6dbdd7ea.png";